$component-class: 'me-container';

.#{$component-class} {
  @include container;
}

@mixin generate-vertical-gap-modifiers($component, $gaps) {
  @each $key, $value in $gaps {
    .#{$component}--y-gap-#{$key} {
      padding-top: $value;
      padding-bottom: $value;
    }

    .#{$component}--y-gap-lg-#{$key} {
      @include desktop {
        padding-top: $value;
        padding-bottom: $value;
      }
    }
  }
}

@mixin generate-horizontal-gap-modifiers($component, $gaps) {
  @each $key, $value in $gaps {
    .#{$component}--x-gap-#{$key} {
      padding-left: $value;
      padding-right: $value;
    }

    .#{$component}--x-gap-md-#{$key} {
      @include desktop {
        padding-left: $value;
        padding-right: $value;
      }
    }

    .#{$component}--x-gap-lg-#{$key} {
      @include desktop-lg {
        padding-left: $value;
        padding-right: $value;
      }
    }
  }
}

@include generate-vertical-gap-modifiers($component-class, $spacings);
@include generate-horizontal-gap-modifiers($component-class, $spacings);
